import { render, staticRenderFns } from "./PackageTab.vue?vue&type=template&id=fca0b47e&scoped=true&"
import script from "./PackageTab.vue?vue&type=script&lang=js&"
export * from "./PackageTab.vue?vue&type=script&lang=js&"
import style0 from "./PackageTab.vue?vue&type=style&index=0&id=fca0b47e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fca0b47e",
  null
  
)

export default component.exports